export default __webpack_public_path__ + "static/media/04.f8e79e1c.jpg";